import { connect } from "react-redux"
import React, { Component } from "react"

import type { Evidence } from "../../types/types"
import { evidenceRemoveItem } from "../../actions/evidence-actions"
import { images } from "../../config/image-definitions"
import BackgroundImage from "./BackgroundImage"

const { placeholderReportImage } = images

type Props = {
    item: Evidence,
    roleID: string,
    isEditMode: boolean,
    onRemoveItem: (Evidence, string) => void
}

function isMachineIdentified(type: String): boolean {
    return type === "ApprovedKnowledge" || type === "Knowledge"
}

class EvidenceListItem extends Component<Props> {
    removeItem = () => {
        this.props.onRemoveItem(this.props.item, this.props.roleID)
    }

    render() {
        const { item, isEditMode } = this.props

        return (
            <div key={item.id} className="stakeholder-evidence-item">
                <div
                    className="stakeholder-evidence-left-block"
                    data-cy="stakeholderEvidenceItem"
                >
                    <BackgroundImage
                        classList={["stakeholder-evidence-image"]}
                        imageUrl={item.image}
                        defaultImageUrl={placeholderReportImage}
                        errorImageUrl={placeholderReportImage}
                    >
                        {isMachineIdentified(item.type) && (
                            <i className="icon-robot" />
                        )}
                    </BackgroundImage>
                    <p className="stakeholder-evidence-publisher">
                        <b>{item.publisher}</b>
                    </p>
                    {isEditMode ? (
                        <p>{item.title}</p>
                    ) : (
                        <a
                            target="_blank"
                            href={item.link}
                            rel="noopener noreferrer"
                        >
                            {item.title}
                        </a>
                    )}
                </div>
                {isEditMode &&
                    !isMachineIdentified(item.type) && (
                        <span
                            className="icon-close-filters"
                            onClick={this.removeItem}
                        >
                            &times;
                        </span>
                    )}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    onRemoveItem: (item, roleID) => dispatch(evidenceRemoveItem(item, roleID))
})

export default connect(null, mapDispatchToProps)(EvidenceListItem)
